import * as types from "../Actions/actions";

const initialState = {isLoggedIn: false};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.LOGIN_USER:
      return { ...state, ...action.userState, isLoggedIn: true };
    default:
      return state;
  }
};

export default userReducer;
